import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const MATH_SENTENCES_ACTIVITY_FRAGMENT = gql `
  fragment MathSentencesActivityFragment on MathSentencesActivity {
    rounds {
      steps {
        answer
      }
      teacherImage {
        image {
          ...AssetFragment
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default MATH_SENTENCES_ACTIVITY_FRAGMENT;
